import gql from 'graphql-tag'

export const famVideo = gql`
  fragment famVideo on Video {
    file
    poster
    transcript
  }
`
